import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatCarousel = createCustomElementWrapper('kat-carousel', 'KatCarousel', {
    'aspectHeight': 'aspect-height',
    'aspectWidth': 'aspect-width',
    'autoCycle': 'auto-cycle',
    'autoCyclePeriodMs': 'auto-cycle-period-ms',
    'disableNavArrows': 'disable-nav-arrows',
    'disableNavDots': 'disable-nav-dots',
    'katAriaLabel': 'kat-aria-label',
}, {
    'onSlideEnd': 'slideEnd',
    'onSlideStart': 'slideStart',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/carousel.js
// module id = 1246
// module chunks = 0